const superstarWorkThroughInjuryTexts = [
    {
        'subject': 'Wrestle',
        'content': 'I know the doctors are saying I should take it easy, but I know my body better. I\'m okay to wrestle.'
    },
    {
        'subject': 'Work',
        'content': 'Listen, I can work with this injury. I\'ll take it easy in my matches until I\'m back to a hundred percent.'
    },
    {
        'subject': 'My place',
        'content': 'This injury isn\'t too serious .. let me work through it. I don\'t want to lose my place.'
    },
    {
        'subject': 'Wrestle',
        'content': 'This injury isn\'t bothering me too much. I\'m pretty sure I can wrestle with it.'
    },
    {
        'subject': 'Careful',
        'content': 'If I\'m careful, I can easily wrestle with this injury until it heals. What do you think?'
    }
];

const superstarAggravatedInjuryTexts = [
    {
        'subject': 'Doctors',
        'content': 'Maybe I should have listened to the doctors, taken it easy for a few months .. I just didn\'t want to lose my place.'
    },
    {
        'subject': 'Bad Idea',
        'content': 'Guess it was a bad idea to work with the injury. I felt like I couldn\'t say no .. actually, I didn\'t want to say no.'
    },
    {
        'subject': 'Rest',
        'content': 'I know I have no one to blame but myself. I guess the silver lining is I get a lot of time to rest and heal now.'
    },
    {
        'subject': 'Heal',
        'content': 'I did what you\'re supposed to do with an injury like that, you know? You fight through it .. it just didn\'t work out this time.'
    }
];

const injuriesData = {
    'workable': {
        'names': ['twisted ankle', 'pulled hamstring', 'broken finger', 'bruised wrist', 'inflamed achilles',
                  'pulled groin', 'shoulder sprain', 'strained bicep', 'pulled calf', 'quad strain', 'sprained knee',
                  'strained pec', 'skin infection', 'concussion'],
        'months_min': 1,
        'months_max': 2,
        'severe_versions': {
            'twisted ankle': 'torn ankle ligament',
            'pulled hamstring': 'hamstring tear',
            'broken finger': 'shattered finger',
            'bruised wrist': 'torn wrist ligament',
            'inflamed achilles': 'ruptured achilles',
            'pulled groin': 'groin tear',
            'shoulder sprain': 'separated shoulder',
            'strained bicep': 'torn bicep',
            'pulled calf': 'ruptured calf',
            'quad strain': 'torn quad',
            'sprained knee': 'torn knee ligament',
            'strained pec': 'torn pec',
            'skin infection': 'staph infection',
            'concussion': 'severe concussion'
        }
    },
    'minor': {
        'names': ['kidney problem', 'torn bicep', 'torn tricep', 'torn pec', 'dislocated shoulder', 'fractured ankle',
                  'staph infection', 'broken rib', 'groin tear', 'torn rotator cuff', 'fractured wrist', 'broken hand',
                  'broken foot', 'broken arm', 'fractured knee', 'torn ankle ligament', 'hamstring tear',
                  'shattered finger', 'torn wrist ligament', 'ruptured achilles', 'ruptured calf',
                  'separated shoulder'],
        'months_min': 3,
        'months_max': 6
    },
    'major': {
        'names': ['broken neck', 'broken back', 'torn knee ligament', 'torn quad', 'severe concussion',
                  'herniated disc', 'broken leg'],
        'months_min': 7,
        'months_max': 13
    }
}

export {superstarAggravatedInjuryTexts, superstarWorkThroughInjuryTexts, injuriesData}